import { useState } from "react"
import { useField } from "formik"
import { Divider, Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { DeliveryFulfillmentType, DeliveryTimesField, DynamicConfigKey } from "../../form/formTypes"
import { ExtraServicesForDelivery } from "./ExtraServicesForDelivery"

const useStyles = makeStyles()(() => ({
    label: {
        fontWeight: 500,
        fontSize: "1rem",
        lineHeight: 1.5,
    },
}))

type ExtraServicesProps = Readonly<{
    userId: number
    merchantId: number
}>

export function ExtraServices({ userId, merchantId }: ExtraServicesProps) {
    const { classes } = useStyles()
    const [{ value: deliveryType }] = useField<DeliveryFulfillmentType>(DynamicConfigKey.DELIVERY_TYPE)
    const [{ value: deliveries }] = useField<DeliveryTimesField>(DynamicConfigKey.MULTIPLE_DELIVERIES)

    const [visibleIndices, setVisibleIndices] = useState<Set<number>>(new Set())

    const deliveryDate = deliveries?.deliveryDate

    if (!deliveryDate || !Array.isArray(deliveries?.deliveryTimes) || deliveries.deliveryTimes.length === 0) {
        return null
    }

    return (
        <>
            {visibleIndices.size > 0 && <Divider />}
            <Stack gap=".75rem">
                {visibleIndices.size > 0 && (
                    <LocalizedStrict id="create-order-extra-services">
                        <Typography variant="body1" className={classes.label}>
                            Extra services:
                        </Typography>
                    </LocalizedStrict>
                )}
                {deliveries.deliveryTimes.map((delivery, index) => (
                    <ExtraServicesForDelivery
                        key={`extra-svc-${delivery.time}-${index}`}
                        userId={userId}
                        merchantId={merchantId}
                        deliveryType={deliveryType}
                        deliveryDate={deliveryDate}
                        deliveryTime={delivery.time}
                        deliveryIndex={index}
                        onVisibilityChange={(visible) =>
                            setVisibleIndices((prev) => {
                                const next = new Set(prev)
                                if (visible) next.add(index)
                                else next.delete(index)
                                return next
                            })
                        }

                    />
                ))}
            </Stack>
        </>
    )
}
